__turbopack_context__.v({
  "actions": "index-module-scss-module__LyRi2q__actions",
  "address": "index-module-scss-module__LyRi2q__address",
  "anchor_button": "index-module-scss-module__LyRi2q__anchor_button",
  "body_text": "index-module-scss-module__LyRi2q__body_text",
  "company_name": "index-module-scss-module__LyRi2q__company_name",
  "google-review": "index-module-scss-module__LyRi2q__google-review",
  "logo": "index-module-scss-module__LyRi2q__logo",
  "main_data": "index-module-scss-module__LyRi2q__main_data",
  "main_info": "index-module-scss-module__LyRi2q__main_info",
  "online_ads": "index-module-scss-module__LyRi2q__online_ads",
  "opening_time_caption": "index-module-scss-module__LyRi2q__opening_time_caption",
  "shop-box-bottom": "index-module-scss-module__LyRi2q__shop-box-bottom",
  "shop_image": "index-module-scss-module__LyRi2q__shop_image",
  "socialization": "index-module-scss-module__LyRi2q__socialization",
  "socializationB": "index-module-scss-module__LyRi2q__socializationB",
  "website_link": "index-module-scss-module__LyRi2q__website_link",
});
